import NotificationElement from './elements/NotificationElement'
import WishlistButtonElement from './elements/WishlistButtonElement'
import WishlistItemElement from './elements/WishlistItemElement'
import WishlistProductSlideoutElement from './elements/WishlistProductSlideoutElement'
import WishlistSlideoutElement from './elements/WishlistSlideoutElement'
import WishlistCreateListElement from './elements/WishlistCreateListElement'
import WishlistDashboardElement from './elements/WishlistDashboardElement'
import WishlistSharedDisplay from './elements/WishlistSharedDisplay'
import AccountHeaderElement from './elements/AccountHeaderElement'
import AccountSlideoutElement from './elements/AccountSlideoutElement'
import ValidateFormCustomElement from './elements/ValidateFormCustomElement'
import { initWishlistProvider } from './helpers/provider-bootstrap'

// import './styles/base.css'

async function onInit() {
  if (GM_STATE.wishlist.enable) {
    await initWishlistProvider()
  }
  window.customElements.define('wishlist-button', WishlistButtonElement)
  window.customElements.define('wishlist-slideout', WishlistSlideoutElement)
  window.customElements.define('wishlist-create-list', WishlistCreateListElement)
  window.customElements.define('wishlist-dashboard', WishlistDashboardElement)
  window.customElements.define('wishlist-item', WishlistItemElement)
  window.customElements.define('wishlist-product-slideout', WishlistProductSlideoutElement)
  window.customElements.define('account-header', AccountHeaderElement)
  window.customElements.define('account-slideout', AccountSlideoutElement)
  window.customElements.define('custom-notification', NotificationElement)
  window.customElements.define('wishlist-shared-display', WishlistSharedDisplay)
  window.customElements.define('validate-form', ValidateFormCustomElement)
}

onInit()
